import React, { useEffect, useState } from "react";
import { useAuth } from "../../Context/store/context";
import config from "../../../config";
import { _get, _post } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";
import { domainsList } from '../../Redux/Actions/DomainsListAction';
import { useDispatch } from "react-redux";

export default function AddDomain({ onClose }) {
  const { logoutuser, showLoader, hideLoader, getToken,fetchUserDetails } = useAuth();
  const dispatch = useDispatch();
  const [domain, setDomain] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!getToken())
      logoutuser();
    else {
      setDomain("");
    }
  }, []);



  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      postData();
    }
  };

  const validate = () => {
    const errors = {};
    if (!domain || (domain && domain.trim() == "")) {
      errors.domain = "Domain name is required";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;

  }

  const postData = async () => {
    showLoader();
    await _post("/app-user-domains", {
      "domainName": domain,
      "isManagedByInvitd": true,
      "isSubdomain": false,
      "isPrimary": false
    })
      .then(() => {
        _showToast("Domain added successfully.", "success");
        fetchDomains();
        fetchUserDetails();
        onClose();
        hideLoader();
      })
      .catch((error) => {
        const errors = {};
        errors.domain = error;
        setErrors(errors);
        _showToast(error, "error");
        hideLoader();
      });
  };

  const fetchDomains = async () => {
    await _get('/app-user-domains')
      .then((response) => {
        dispatch(domainsList(response));
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }
  return (
    <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Domain</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3 row align-items-center">
                <label className="form-label col-12 required">
                  Domain
                </label>
                <div className="col-12">
                  <div className="d-flex flex-col align-items-center">
                    <span className="me-1">
                      {config.invitationPageBaseUrl}/
                    </span>
                    <input
                      type="text"
                      className={`form-control ${errors.domain ? "is-invalid" : ""}`}
                      name="domain"
                      value={domain}
                      placeholder="Domain name"
                      onChange={(e) => setDomain(e.target.value)}
                    />
                  </div>
                  {errors.domain && (
                    <div className="text-danger">
                      {errors.domain}
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between">
                <div className="text-start">
                  <button type="button" className="btn btn-secondary" onClick={onClose}>
                    Close
                  </button>
                </div>
                <div className="text-end">
                  <button type="submit" className="btn btn-primary"  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
